import { useState } from "react";
import SprintPlan from "./SprintPlan";
import NewsroomAI from "./NewsroomAI";
import Kickoff from "./Kickoff";
import useIsMobile from "./useIsMobile";

export default function App() {
  const [active, setActive] = useState("sprint");
  const mob = useIsMobile();

  return (
    <div style={{ fontFamily: "'IBM Plex Sans', sans-serif", background: "#070d1a", minHeight: "100vh" }}>
      {/* Nav */}
      <div style={{
        position: "sticky", top: 0, zIndex: 100,
        background: "#070d1a",
        borderBottom: "1px solid #1e2d42",
        display: "flex", alignItems: "center", gap: 0,
        padding: mob ? "0 10px" : "0 48px",
        height: 44,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginRight: mob ? 8 : 32 }}>
          <div style={{ width: 18, height: 18, background: "#3b82f6", borderRadius: 3, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <span style={{ fontSize: 10, fontWeight: 900, color: "#fff" }}>S</span>
          </div>
          {!mob && <span style={{ fontSize: 12, fontWeight: 700, color: "#64748b", letterSpacing: "0.05em" }}>AI PRODUCTION ENGINE</span>}
        </div>
        {[
          { id: "kickoff", label: "Kickoff" },
          { id: "sprint", label: mob ? "Sprint" : "Sprint Plan" },
          { id: "newsroom", label: mob ? "Newsroom" : "Newsroom AI Prototype" },
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActive(tab.id)}
            style={{
              fontSize: mob ? 11 : 12, fontWeight: 600,
              padding: mob ? "0 8px" : "0 16px", height: 44,
              background: "transparent", border: "none",
              borderBottom: `2px solid ${active === tab.id ? "#3b82f6" : "transparent"}`,
              color: active === tab.id ? "#93c5fd" : "#475569",
              cursor: "pointer", transition: "all 0.15s",
              whiteSpace: "nowrap",
            }}
          >{tab.label}</button>
        ))}
        {!mob && (
          <div style={{ marginLeft: "auto", fontSize: 10, color: "#334155", fontFamily: "monospace" }}>
            AI Foundations Team · Internal use only
          </div>
        )}
      </div>

      {/* Content */}
      {active === "kickoff"   && <Kickoff />}
      {active === "sprint"    && <SprintPlan />}
      {active === "newsroom"  && <NewsroomAI />}
    </div>
  );
}
